import React from 'react';
import CenteredLayout from './centered/CenteredLayout';
import ImmersiveLayout from './immersive/ImmersiveLayout';
import SplitScreenLayout from './split-screen/SplitScreenLayout';
// import FullPageLayout from './full-page/FullPageLayout';

interface LayoutSwitcherProps {
  children: React.ReactNode;
  layoutType?: string | null;
  backgroundColor?: string | null;
}

const LayoutSwitcher: React.FC<LayoutSwitcherProps> = ({
  children,
  layoutType,
  backgroundColor
}) => {
  switch (layoutType) {
    case 'immersive':
      return <ImmersiveLayout>{children}</ImmersiveLayout>;
    case 'split-screen':
      return <SplitScreenLayout backgroundColor={backgroundColor}>{children}</SplitScreenLayout>;
    // case 'full-page':
    //   return <FullPageLayout backgroundColor={backgroundColor}>{children}</FullPageLayout>;
    case 'centered':
    default:
      return <CenteredLayout backgroundColor={backgroundColor}>{children}</CenteredLayout>;
  }
};

export default LayoutSwitcher;
